var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("div", { staticClass: "letter-wrap" }, [
                  _c("div", { staticClass: "note-wrap" }, [
                    _c("div", { staticClass: "letter-title" }, [
                      _vm._v(" 提醒報到 "),
                    ]),
                    _c("div", { staticClass: "note-title" }, [
                      _vm._v("可動態套入信件內容，請參考以下參數"),
                    ]),
                    _c("div", { staticClass: "note-table" }, [
                      _vm.mailParameter
                        ? _c(
                            "table",
                            _vm._l(_vm.mailParameter, function (item, index) {
                              return _c("tr", { key: index }, [
                                _c("th", [
                                  _vm._v(_vm._s(item.MailParameterName)),
                                ]),
                                _c("td", [
                                  _c("span", [_vm._v("{{")]),
                                  _vm._v(_vm._s(item.MailParameterCode)),
                                  _c("span", [_vm._v("}}")]),
                                ]),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _c("form", [
                    _c("div", { staticClass: "info-wrap" }, [
                      _c("div", { staticClass: "field-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("ValidationProvider", {
                              staticClass: "w-100",
                              attrs: {
                                tag: "div",
                                name: _vm.i18n("Template.MailSubject"),
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "label",
                                          { attrs: { for: "input-subject" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "Template.MailSubject"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.trim",
                                              value:
                                                _vm.mail.MailTemplateSubject,
                                              expression:
                                                "mail.MailTemplateSubject",
                                              modifiers: { trim: true },
                                            },
                                          ],
                                          staticClass: "form-control w-100",
                                          attrs: {
                                            type: "text",
                                            id: "input-subject",
                                          },
                                          domProps: {
                                            value: _vm.mail.MailTemplateSubject,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.mail,
                                                "MailTemplateSubject",
                                                $event.target.value.trim()
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                        errors[0]
                                          ? _c(
                                              "p",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("ValidationProvider", {
                          staticClass: "w-100",
                          attrs: {
                            tag: "div",
                            name: _vm.i18n("Template.MailContent"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.i18n("Template.MailContent")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("VueEditor", {
                                      staticStyle: {
                                        background: "rgb(255, 255, 255)",
                                      },
                                      model: {
                                        value: _vm.mail.MailTemplateBody,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.mail,
                                            "MailTemplateBody",
                                            $$v
                                          )
                                        },
                                        expression: "mail.MailTemplateBody",
                                      },
                                    }),
                                    errors[0]
                                      ? _c(
                                          "p",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-wrap center",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.updateMailTemplate)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }